// import EntypoIcon from 'react-native-vector-icons/Entypo'

// import BackIcon from '../../components/BackIcon'
// import XTabNavIcon from '../../components/XTabNavIcon'

import BaseUITextEditorView from 'xui/modules/textEditor/BaseUITextEditorView'

export default class TextEditorView extends BaseUITextEditorView {}
